import { SortDescriptor } from '@progress/kendo-data-query'
import { PaymentAgentFilterKey, PaymentAgentKey } from 'api/Wallet/Types/PaymentAgentDto'

export const normalizePaymentAgentsSortQuery = (
  sortDescriptors: SortDescriptor[]
): SortDescriptor[] =>
  sortDescriptors
    .map((x) => {
      if (x.field === PaymentAgentKey.client) {
        return { ...x, field: PaymentAgentFilterKey.client }
      }
      if (x.field === PaymentAgentKey.name) {
        return { ...x, field: PaymentAgentFilterKey.name }
      }
      return x
    })
    .filter((x) => !!x)
